import { css } from '@emotion/react';
import { theme } from '../../domain/theme';

export const ngartImg = css`
  margin-bottom: 30px;

  &:hover {
    cursor: pointer;
  }
`;

export const ngartImgCntr = css`
  position: relative;
  font-size: 0;
`;

export const ngartImgCont = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 20px;
  color: #333;
  border-left: 1px solid #555;
  max-width: 100%;
  position: relative;
  cursor: auto;

  & p {
    ${theme.font.family('regularWeb')};
    font-weight: 400;
    font-size: 0.875rem;
    letter-spacing: 0.1px;
    line-height: 20px;
    color: #333;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 8px;
    background: #fff;
    z-index: 2;
  }

  ${theme.mq.tablet} {
    & {
      width: 100%;
    }
  }
`;

export const ngartImgContAuthor = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 3px;
  line-height: 1.5;
  text-transform: uppercase;
  color: #333;
`;

export const ngartImgContCopy = css`
  color: #555;

  & p {
    margin: 0 !important;
  }

  & p a:any-link {
    border-bottom: 2px solid #fc0;
    color: #555;
  }
`;

export const ngartImgContCredit = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 3px;
  line-height: 1.5;
  text-transform: uppercase;
  color: #333;
`;

export const ngartImgContStrong = css`
  & a {
    color: #fff;
  }

  font-weight: 700;
`;

export const ngartImgPlayButton = css`
  height: 80px;
  width: 56px;
  background: rgba(0, 0, 0, 0.8);
  z-index: 14;

  &:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-bottom: 11px solid transparent;
    border-top: 11px solid transparent;
    border-left: 19px solid #fc0;
    font-size: 0;
  }

  &:hover {
    background: #fc0;
  }

  &:hover:after {
    border-left-color: #000 !important;
  }

  position: absolute;
  bottom: 0;
  left: 0;
  height: 62px;
  width: 44px;
  cursor: pointer;

  &:after {
    border-bottom: 8px solid transparent;
    border-top: 8px solid transparent;
    border-left: 15px solid #fc0;
  }
`;

export const ngartImgViewGallery = css`
  ${theme.font.family('regularWeb')};
  font-weight: 400;
  font-size: 0.75rem;
  letter-spacing: 3px;
  line-height: 1.5;
  color: #fff;
  font-size: 0.75rem;
  line-height: 0;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
`;

export const ngartImgGallery = css`
  position: relative;
  margin: 60px 0;
  clear: left;
  font-size: 0;
  line-height: 0;
  background: #fff;
`;

export const ngartImgGalleryItemImages = css`
  ${theme.mq.small_desktop} {
    & {
      display: flex;
      align-items: flex-end;
    }
  }
`;

export const ngartImgGalleryOpenBtn = css`
  font-size: 1.25rem;
  color: #fff;
  background: #000;
  padding: 20px;
  position: relative;
  line-height: 0;
  background: #000;
  display: block;
  float: left;
`;

export const ngartImgGalleryAd = css`
  ${theme.mq.small_desktop} {
    & {
      width: 30%;
      margin-left: 55px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      margin-left: 60px;
    }
  }
`;

export const ngartImgGalleryPromo = css`
  ${theme.mq.small_desktop} {
    & {
      width: 100%;
    }
  }
`;

export const ngartImgArtMainCol = css`
  & .ngart-img__cont {
    margin-top: 13px;
    padding-left: 15px;
    padding-right: 30px;
  }

  & .ngart-img__cont:before & .ngart-img__cont:before,
  & .ngart-img__cont:before .ngart-img--medium .ngart-img__cont:before {
    height: 4px;
  }

  &.ngart-img--video .ngart-img__play-button {
    height: 80px;
    width: 57px;
  }

  & .ngart-img__cont__copy {
    margin-bottom: 10px;
  }

  ${theme.mq.tablet} {
    & .ngart-img__cont {
      margin-top: 10px;
      padding-left: 15px;
      max-width: 760px;
    }
  }

  ${theme.mq.small_desktop} {
    & .ngart-img__cont {
      margin-top: 20px;
      padding-left: 40px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      max-width: 760px;
      display: block;
    }

    & .ngart-img__cont {
      margin: 20px 0 30px;
      padding-left: 40px;
    }

    & .ngart-img__cont__copy {
      margin-bottom: 20px;
    }

    & .ngart-img__cntr img {
      max-width: 760px;
    }
  }
`;

export const ngartImgVideo = css`
  & .ngart-img__cont__copy {
    ${theme.font.family('regularWeb')};
    font-weight: 400;
    font-size: 0.9375rem;
    letter-spacing: 0.1px;
    line-height: 1.5;
  }

  float: none;

  & .ngart-img__cntr {
    overflow: hidden;
  }

  &:hover {
    cursor: pointer;
  }

  & .overlay-image {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 30;
    min-height: 100%;
    height: auto;
    width: 100%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  & .overlay-image.hide {
    display: none;
  }

  & .ngs-video {
    z-index: 20;
  }

  & .ngart-img__play-button {
    z-index: 31;
  }

  & .ngart-img__play-button.hide {
    display: none;
  }

  & .ngart-img__cont__heading {
    ${theme.font.family('boldWeb')};
    font-weight: 400;
    font-size: 0.875rem;
    letter-spacing: 2.5px;
    line-height: 1.5;
    text-transform: uppercase;
    color: #333;
  }

  & .ngart-img__cont__copy {
    margin-bottom: 0 !important;
    color: #555;
  }

  ${theme.mq.small_desktop} {
    & .overlay-image {
      position: relative;
      top: 0;
      left: 0;
      z-index: 30;
      min-height: 100%;
      height: auto;
      width: 100%;
      transform: none;
    }
  }
`;
export const ngartImgLarge = css`
  margin-bottom: 30px;
  width: 100%;
  clear: both;

  & .ngart-img__cont {
    padding-left: 30px;
    position: relative;
    margin: 11px 0;
  }

  &.ngart-img--video .ngart-img__play-button {
    height: 80px;
    width: 57px;
  }

  float: none;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;

  & .close {
    top: -3px;
  }

  & .ngart-img__cntr {
    display: block;
    overflow: hidden;
    margin-left: 0;
    margin-right: 0;
  }

  & .ngart-img__cont__copy {
    margin-bottom: 10px;
  }

  ${theme.mq.tablet} {
    & .ngart-img__cont {
      padding-left: 35px;
      margin: 10px 80px 31px 0;
    }

    & .ngart-img__cont {
      margin: 11px 0;
    }
  }

  ${theme.mq.small_desktop} {
    & .ngart-img__cont {
      padding-left: 35px;
      margin: 20px 30px 0 0;
    }

    & .ngart-img__cont {
      margin: 11px 0;
    }

    & .ngart-img__cont__copy {
      margin-right: 320px;
    }
  }

  ${theme.mq.large_desktop} {
    & .ngart-img__cont {
      padding-left: 40px;
      margin: 10px 0 0;
      width: 100%;
    }

    & .ngart-img__cont__copy {
      margin-bottom: 10px;
      margin-right: 80px;
    }

    & .ngart-img__cntr img {
      margin: 0 auto;
      display: block;
      width: 100%;
    }

    & .ngart-img__cont {
      margin: 11px auto 0;
      max-width: 1160px;
    }

    & .ngart-img__cont__copy {
      max-width: 780px;
    }
  }
`;

export const ngartImgMedium = css`
  & .ngart-img__cont {
    margin-top: 13px;
    padding-left: 15px;
    padding-right: 30px;
  }

  &.ngart-img--video .ngart-img__play-button {
    height: 80px;
    width: 57px;
  }

  & .ngart-img__cont__copy {
    margin-bottom: 10px;
  }

  ${theme.mq.tablet} {
    & .ngart-img__cont {
      margin-top: 10px;
      padding-left: 15px;
      max-width: 760px;
    }
  }

  ${theme.mq.small_desktop} {
    & .ngart-img__cont {
      margin-top: 20px;
      padding-left: 40px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      max-width: 760px;
      display: block;
    }

    & .ngart-img__cont {
      margin: 20px 0 30px;
      padding-left: 40px;
    }

    & .ngart-img__cont__copy {
      margin-bottom: 20px;
    }

    & .ngart-img__cntr img {
      max-width: 760px;
    }
  }
`;

export const ngartImgGalleryControls = css`
  background: rgba(0, 0, 0, 0.5);
  width: 260px;
  overflow: hidden;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;

  & .ngart-img__view-gallery {
    display: block;
    height: 60px;
    line-height: 3.75rem;
  }

  &:hover {
    background: #000;
  }

  &:hover .ngart-img__view-gallery {
    color: #fc0;
  }

  &:hover .ngart-img--gallery__open-btn {
    background: #fc0;
    color: #000;
  }

  ${theme.mq.small_desktop} {
    & {
      width: 260px;
    }
  }
`;

export const ngartImgSmall = css`
  margin-bottom: 30px;

  & .ngart-img__cont {
    margin-top: 13px;
    padding-left: 15px;
    padding-right: 30px;
  }

  & .ngart-img__cont__copy {
    margin-bottom: 10px;
  }

  ${theme.mq.tablet} {
    & {
      width: 50%;
      margin: 0 20px 45px 0;
      display: inline-block;
      float: left;
      clear: left;
    }

    & .ngart-img__cont {
      margin-top: 10px;
      padding-left: 30px;
    }
  }

  ${theme.mq.small_desktop} {
    & {
      margin: 0 30px 40px 0;
      max-width: 315px;
    }

    & .ngart-img__cont {
      margin-top: 20px;
      padding-left: 30px;
    }
  }

  ${theme.mq.large_desktop} {
    & {
      margin: 0 30px 30px 0;
    }

    & .ngart-img__cont {
      margin-top: 20px;
      padding-left: 30px;
    }

    & .ngart-img__cont__copy {
      margin-bottom: 20px;
    }
  }
`;
export const ngartImgSize = {
  large: ngartImgLarge,
  medium: ngartImgMedium,
  small: ngartImgSmall
};
